import React, {useEffect} from 'react'
import { useTranslation, Trans } from 'react-i18next'
import {Form, Button, Input, Typography} from 'antd'
import {withTitle} from '@/router/utils'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {ROUTES} from '@/router/routes'
import {VERIFICATION_CODE_LENGTH} from '@/constants'
import {Card, ResendButton} from '@/components'
import {BackButton} from '@/components'
import {IValidateOtpCodeStore} from './IValidateOtpCodeStore'

import styles from './styles.scss'

export const ValidateOtpCodeStoreSymbol = Symbol('ValidateOtpCodeStore')

const ValidateOtpCode = observer(() => {
    const {t} = useTranslation()
    const store = useInjection<IValidateOtpCodeStore>(ValidateOtpCodeStoreSymbol)
    const {email, isLoading, validateCode, resendCode, validateEmailPresence} = store
    const [form] = Form.useForm()
    const formId = 'validate-otp'

    useEffect(() => {
        validateEmailPresence()
    }, [])

    const handleSubmit = async ({verificationCode}) => {
        await validateCode(verificationCode)
    }

    return (
        <div className={styles.root}>
            <BackButton
                to={ROUTES.signUpValidateEmail}
                className={styles.backButton}
                title={t('ValidateOtpCode.changeEmail')}
            />

            <Card title={t('ValidateOtpCode.title')}>
                <Typography.Text className={styles.text}>
                    <Trans
                        i18nKey={'ValidateOtpCode.text'}
                        values={{n: VERIFICATION_CODE_LENGTH, email: email || ''}}
                        components={{ strong: <strong /> }}
                    />
                </Typography.Text>

                <Form
                    form={form}
                    id={formId}
                    layout={'vertical'}
                    requiredMark={false}
                    onFinish={handleSubmit}
                >
                    <Form.Item
                        label={t('ValidateOtpCode.otp')}
                        name={'verificationCode'}
                        rules={[{required: true, message: t('ValidateOtpCode.otpRequired')}]}
                    >
                        <Input
                            maxLength={VERIFICATION_CODE_LENGTH}
                            placeholder={t('ValidateOtpCode.otp')}
                            data-test-id={'code'}
                        />
                    </Form.Item>
                    <Typography.Text className={styles.resend}>
                        {t('ValidateOtpCode.resendMessage')}{' '}
                        <ResendButton text={t('ValidateOtpCode.resendText')} onResend={resendCode} />
                    </Typography.Text>
                    <Form.Item key={'submit'}>
                        <Button
                            form={formId}
                            type={'primary'}
                            htmlType={'submit'}
                            className={styles.submit}
                            loading={isLoading}
                        >
                            {t('ValidateOtpCode.submit')}
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    )
})

export default withTitle(ValidateOtpCode)
